import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'

/**
 * Common component, Button Icon with Tooltip
  @param {String} icon Icon FontAwesome 
  @param {String} title title tooltip
  @param {String} placement postion tooltip, value =  top, bottom
  @param {Boolean} disabled disabled buttom
  @param {String} className class name style
  @param {String} classNameIcon class name style icon
  @param {Object} style object style
  @param {Function} onClick event on click buttom
  @param {Boolean} spin spin the icon (loading state)
 */

const IconTooltipButton = ({
  icon,
  title,
  placement = 'top',
  disabled,
  className,
  classNameIcon,
  onClick,
  style,
  color,
  variant = 'circle',
  spin = false,
  ref
}) => {
  return (
    <Tooltip arrow title={title} placement={placement} key={`icon-buttom-${title}`}>
      <span>
        <IconButton
          ref={ref}
          variant={variant}
          color={color}
          onClick={onClick}
          className={className}
          style={style}
          disabled={disabled}
          size='large'
        >
          <FontAwesomeIcon icon={icon} className={classNameIcon} spin={spin} />
        </IconButton>
      </span>
    </Tooltip>
  )
}

export default IconTooltipButton
